import HomeSection1 from "./section1/HomeSection1"
import HomeSection2 from "./section2/HomeSection2"
import { Wrapper } from "./HomeStyle"


const Home = ({resetPasswordMode}) => {
  return (
    <Wrapper>
      <HomeSection1 resetPasswordMode={resetPasswordMode} />
      <HomeSection2 />
    </Wrapper>
  )
}


export default Home
